var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3C8.754 3 6 5.291 6 8.25v2.25h4.5V8.25c0-.111.067-.272.328-.445.26-.173.686-.305 1.172-.305.49 0 .914.132 1.172.305.258.173.328.322.328.445 0 .434-.14.735-.422 1.078-.281.343-.718.697-1.195 1.102-.958.811-2.133 1.942-2.133 3.82V15h4.5v-.75c0-.255.094-.434.375-.727s.747-.638 1.242-1.054C16.857 11.637 18 10.362 18 8.25 18 5.317 15.252 3 12 3Zm0 1.5c2.546 0 4.5 1.775 4.5 3.75 0 1.608-.732 2.326-1.617 3.07-.443.372-.914.736-1.336 1.172a2.97 2.97 0 0 0-.61 1.008h-1.453c.235-.759.692-1.336 1.383-1.922.46-.387.961-.79 1.383-1.312.422-.522.75-1.204.75-2.016 0-.72-.428-1.318-.984-1.688C13.459 6.194 12.753 6 12 6c-.756 0-1.462.193-2.016.563C9.431 6.931 9 7.532 9 8.25V9H7.5v-.75C7.5 6.237 9.448 4.5 12 4.5Zm-2.25 12V21h4.5v-4.5h-4.5Zm1.5 1.5h1.5v1.5h-1.5V18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f7ca4e49ec7c1edec7dc261915072524.svg";
export { ForwardRef as ReactComponent };